import type { HelpFile } from '../../types/help'
import { ApprovalPolicyDetailTestIds } from '../../../testids/ApprovalPolicyDetailTestIds'

export const approvalPolicyDetailHelp: HelpFile = {
  docPage: '/docs/governance/approval-policies',
  texts: {
    [ApprovalPolicyDetailTestIds.approvalPolicyDetailPage]:
      'Detailseite einer Genehmigungsrichtlinie — legt fest, unter welchen Bedingungen eine Genehmigung erforderlich ist und welche Genehmigerkette läuft, wenn die Bedingungen zutreffen.',
    [ApprovalPolicyDetailTestIds.cardPolicyDetails]:
      'Allgemeine Metadaten der Genehmigungsrichtlinie: Name, Beschreibung, Typ, Verantwortlicher und Audit-Felder.',
    [ApprovalPolicyDetailTestIds.cardTitlePolicyConditions]:
      'Bedingungen, die festlegen, wann diese Richtlinie greift. Alle Bedingungen müssen zutreffen, damit die Richtlinie für eine eingehende Anfrage ausgewählt wird.',
    [ApprovalPolicyDetailTestIds.cardTitlePolicySteps]:
      'Geordnete Liste der Genehmigungsschritte, die nach erfolgreicher Auswahl der Richtlinie ausgeführt werden. Jeder Schritt hat seinen eigenen Resolver und seine eigene Strategie.',
    [ApprovalPolicyDetailTestIds.badgePolicyType]:
      'Typ der Genehmigungsrichtlinie — z. B. Zugriffsanfrage, Verstoß gegen eine Einschränkungsregel oder Wiedereinstellungs-Entscheidung.',
    [ApprovalPolicyDetailTestIds.btnEdit]:
      'Diese Genehmigungsrichtlinie bearbeiten: Bedingungen, Schritte oder Metadaten ändern.',
    [ApprovalPolicyDetailTestIds.btnDelete]:
      'Diese Genehmigungsrichtlinie dauerhaft löschen — der Vorgang kann nicht rückgängig gemacht werden und schlägt fehl, wenn die Richtlinie noch genutzt wird.',
    [ApprovalPolicyDetailTestIds.colField]:
      'Feld der Anfrage, dessen Wert von der Bedingung geprüft wird (z. B. Zugriffsprofil, Zielsystem oder Parteityp).',
    [ApprovalPolicyDetailTestIds.colOperator]:
      'Vergleichsoperator der Bedingung (gleich, in, beginnt mit, …).',
    [ApprovalPolicyDetailTestIds.colValue]:
      'Wert, den das Anfragefeld erfüllen muss, damit die Bedingung greift.',
    [ApprovalPolicyDetailTestIds.colStepOrder]:
      'Position des Genehmigungsschritts in der Kette — Schritte werden in aufsteigender Reihenfolge ausgeführt.',
    [ApprovalPolicyDetailTestIds.colResolverType]:
      'Art der Auflösung der Genehmiger — feste Identität, Rolle, Vorgesetzter des Anforderers, Verantwortlicher des Ziels, …',
    [ApprovalPolicyDetailTestIds.colResolverParam]:
      'Parameter, den der Resolver verwendet — z. B. Rollenname oder Verweis auf eine feste Identität.',
    [ApprovalPolicyDetailTestIds.colApprovalStrategy]:
      'Wie Genehmiger-Entscheidungen im Schritt zusammengeführt werden — einzelner Genehmiger, alle erforderlich oder einer von mehreren.',
    [ApprovalPolicyDetailTestIds.colRequired]:
      'Ob dieser Schritt verpflichtend ist oder übersprungen werden darf, wenn kein Genehmiger ermittelt wurde.',
  },
}
